import axios from "libs/axios";
import { useQuery, UseQueryOptions } from "react-query";
import { AxiosError } from "axios";
import { WageDTO } from "../type";
import { useAppSelector } from "store";
interface wageRequest {
  PageNumber?: number;
  PageSize?: number;
  AcceptorCode: string;
}

const wages = async (data: wageRequest) => {
  return await axios
    .get<WageDTO>(`/api/v1/SettlementData/get-by-acceptor-code`, {
      params: { ...data, version: "1" },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

export const useWages = (
  data: Omit<wageRequest, "AcceptorCode">,
  options?: UseQueryOptions<WageDTO, AxiosError>
) => {
  const shopAndAcceptor = useAppSelector((state) => state.shopAndAcceptor);
  return useQuery<WageDTO, AxiosError>(
    ["/api/v{1/CheckoutWage/get-all", data.PageNumber, shopAndAcceptor],
    async () =>
      wages({
        PageNumber: data.PageNumber,
        PageSize: data.PageSize,
        AcceptorCode: shopAndAcceptor.shaparakAcceptors?.acceptorCode || "",
      }),
    {
      enabled: !!shopAndAcceptor.shaparakAcceptors?.acceptorCode,
      ...options,
    }
  );
};
